import { PrimaryColors } from 'src/types/globalTypes';
import DropdownInfo from 'src/components/ui-kit/DropdownInfo';
import { PatentAnnuity } from 'src/types/api/patentRightsApiTypes';
import { Table, Item, Title, Content } from 'src/components/contents/detail/DetailPage';

interface Iprops {
  data: PatentAnnuity;
  isShow: boolean;
  setIsShow: (isShow: boolean) => void;
  colorType: PrimaryColors;
  noContent: JSX.Element;
}

/**
 * 專利案件年費繳納紀錄 區塊。
 */
const InfoPatentAnnuity: React.FC<Iprops> = ({ data, isShow, setIsShow, colorType, noContent }) => {
  const tableColor = colorType.third;
  const angleColor = colorType.fifth;
  return (
    <DropdownInfo
      title={`專利案件年費繳納紀錄`}
      isShow={isShow}
      setIsShow={setIsShow}
      color={angleColor}
    >
      <Table color={tableColor}>
        <Item>
          <Title>年費有效日期</Title>
          <Content>{data.chargeExpiredDate || noContent}</Content>
          <Title>年費有效年次</Title>
          <Content>{data.chargeExpiredYear || noContent}</Content>
        </Item>
      </Table>
    </DropdownInfo>
  );
};

export default InfoPatentAnnuity;
